module.exports = __webpack_public_path__ + "static/media/如何领取@2x.8c99ab03.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/如何领取@2x.png
// module id = 1587
// module chunks = 0